import { Box, Button, Heading, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import BadgeCard, { BadgeCardProps } from './BadgeCard';
import ModalTemplate from '../../common/ModalTemplate';
import { useAllBadges } from '../../../hooks/V2/useUser';
import { useUserProfile } from '../../../hooks/useUser';
import ShareModal from '../../common/V2/SocialMedia/ShareModal';
import { useNavigate } from 'react-router-dom';
import ActiveBadgeModal from './ActiveBadgeModal';

const Badges = () => {
	const [badgeModal, setBadgeModal] = useState(false);
	const [activeBadge, setActiveBadge] = useState<BadgeCardProps['badge'] | null>(null);

	const { data: badges } = useAllBadges();
	const { data: userProfile } = useUserProfile();
	const [isOpen, setIsOpen] = useState(false);
	const onClose = () => setIsOpen(false);
	const [badgesList, setBadgesList] = useState([]);

	useEffect(() => {
		if (badges) {
			setBadgesList(
				// @ts-ignore
				badges.map(badge => ({
					name: badge?.name,
					isBadgeEarned: userProfile?.badges.includes(badge?._id),
					badgeIcon: badge?.meta?.badgeIcon,
					badgeCard: badge?.meta?.badgeCard,
					disabledBadgeTagLine: badge?.meta?.disabledBadgeTagLine,
					badgeTagLine: badge?.meta?.badgeTagLine,
				})),
			);
		}
	}, [badges, userProfile?.badges]);
	const navigate = useNavigate();

	return (
		<Box h="full">
			<Box h="full" p="16px" pt={{ lg: '56px' }}>
				<Box display={'grid'}>
					<Text mx="auto" textAlign="center" textStyle={{ base: 'h5', lg: 'h3' }} color="#4358F6">
						{userProfile?.badges?.length} {userProfile?.badges?.length <= 1 ? 'badge ' : 'badges '} collected
					</Text>
					<Text textAlign={'center'} mt="12px" textStyle="body1-md" color="#544D4F">
						Start taking quizzes, and attend masterclasses to unlock badges.
					</Text>
				</Box>
				<Box
					maxW="847px"
					mx="auto"
					mt="24px"
					justifyContent="center"
					display={{ base: 'grid', sm: 'flex' }}
					gridTemplateColumns="1fr 1fr"
					flexWrap="wrap"
					gap="20px"
				>
					{badgesList.map((badge, i) => {
						return <BadgeCard badge={badge} key={i} onClick={badge => setActiveBadge(badge)} />;
					})}
				</Box>
			</Box>
			<ModalTemplate
				title=""
				marginX={2}
				bgColor="white"
				maxWidth="475px"
				isOpen={activeBadge ? true : false}
				modalContentProps={{ shadow: 'none', p: '0px' }}
				modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
				onClose={() => setActiveBadge(null)}
			>
				{activeBadge?.isBadgeEarned ? (
					<ActiveBadgeModal
						badgeTagLine={activeBadge?.badgeTagLine}
						name={activeBadge?.name}
						badgeIcon={activeBadge?.badgeIcon}
						setIsOpen={setIsOpen}
					/>
				) : (
					<Box p="40px" rounded="24px" bg="#FFF9E5" textAlign="center">
						<Image mx="auto" h="208px" filter={activeBadge?.isBadgeEarned ? '' : 'grayscale(1)'} src={activeBadge?.badgeIcon} alt="Badge" />
						<Text mt="20px" textStyle="h3">
							{activeBadge?.name}
						</Text>
						<Text mt="12px" textStyle="h6" color="#6C6768">
							{activeBadge?.disabledBadgeTagLine}
						</Text>
						<Button
							onClick={() => {
								navigate('/dashboard');
							}}
							variant="primary"
							bg="#4358F6"
							mt="32px"
						>
							start practicing
						</Button>
					</Box>
				)}
			</ModalTemplate>
			<ShareModal title="Hurray! I have earned a new badge." shareUrl={activeBadge?.badgeCard || ''} isOpen={isOpen} onClose={onClose} />
		</Box>
	);
};

export default Badges;
